// 사이트 전역 SEO 상수 및 JSON-LD 공통 노드.
// canonical/og:url/구조화 데이터에서 window.location.origin 대신 이 고정 도메인을
// 사용해, 접속 호스트(퓨니코드/프리뷰 도메인 등)에 상관없이 항상 대표 URL을 노출한다.

export const SITE_URL = "https://www.xn--vb0b67vepvv2b.com";
export const SITE_NAME = "희망과학 심리상담센터";
export const OG_IMAGE = `${SITE_URL}/images/opengraph.png`;
export const LOGO_URL = `${SITE_URL}/images/logo.png`;

export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

// 홈페이지에 실제로 표시되는 기관 정보와 동일하게 유지한다.
export const ORG_TELEPHONE = "010-2952-1960";
export const ORG_EMAIL = "hopescience0110@naver.com";

// 절대 URL 헬퍼: 상대경로(/foo)는 도메인을 붙이고, 이미 절대 URL이면 그대로 둔다.
export const absoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return undefined;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
};

// 날짜 문자열을 구조화 데이터용 ISO 8601로 변환한다. 파싱 실패 시 undefined.
export const toIso8601 = (dateInput) => {
  if (!dateInput) return undefined;
  const d = new Date(dateInput);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
};

// HTML 문자열에서 첫 번째 <img> 의 src(대표 이미지)를 절대 URL로 추출한다.
// 이미지가 없으면 undefined (로고 등을 강제로 넣지 않기 위함).
export const firstImageFromHtml = (html) => {
  if (typeof html !== "string") return undefined;
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
  if (!match) return undefined;
  return absoluteUrl(match[1]);
};

// 페이지 경로로 canonical URL을 만든다. ("/" → 도메인 루트)
export const canonicalUrl = (path = "/") => {
  if (!path || path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};

// Organization 노드(@id 참조용 전체 정의). 메인페이지 @graph에서 사용하고,
// 다른 구조화 데이터에서는 { "@id": ORG_ID } 로 참조만 한다(중복 정의 방지).
export const ORGANIZATION_NODE = {
  "@type": "Organization",
  "@id": ORG_ID,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: {
    "@type": "ImageObject",
    url: LOGO_URL,
  },
  image: {
    "@type": "ImageObject",
    url: OG_IMAGE,
    width: 1200,
    height: 630,
  },
  telephone: ORG_TELEPHONE,
  email: ORG_EMAIL,
  address: {
    "@type": "PostalAddress",
    streetAddress: "상원6길 8, 비1층 이72호",
    addressLocality: "성동구",
    addressRegion: "서울특별시",
    addressCountry: "KR",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: ORG_TELEPHONE,
    contactType: "customer service",
    availableLanguage: ["Korean"],
  },
};

// 다른 구조화 데이터에서 Organization을 참조할 때 쓰는 최소 노드.
export const ORG_REF = { "@id": ORG_ID };

// author/publisher 등에 쓰는 Organization 축약 노드(로고 포함).
export const ORG_PUBLISHER_NODE = {
  "@type": "Organization",
  "@id": ORG_ID,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: {
    "@type": "ImageObject",
    url: LOGO_URL,
  },
};
